import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";
const proxy = GetProxy();
const cookies = new Cookies();


export const getApplicationList = createAsyncThunk(
  "get/getApplicationList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");

    const { userRole } =props;
    console.log("userRoleuserRoleuserRoleuserRoleuserRole", userRole);
    try {
      const response = await fetch(
        `${proxy}/api/v1/marketPlace/getApplicationNameMarketPlace`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        }
      )
      handleResponseCode(response);
      const data = await response.json(); 
          
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const SaveMarketCost = createAsyncThunk(
  "post/SaveMarketCost",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");

    const { payload } =props;
    try {
      const response = await fetch(
        `${proxy}/api/v1/marketPlace/saveOrUpdateMarketPlaceCost`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      )
      handleResponseCode(response);
      const data = await response.json(); 
          
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);


export const getMarketplaceCostList = createAsyncThunk(
  "post/getMarketplaceCostList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");

    const { payload, pageNumber, pageLimit } =props;
    try {
      const response = await fetch(
        `${proxy}/api/v1/marketPlace/list/getMarketPlaceCost/${pageNumber}/${pageLimit}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      )
      handleResponseCode(response);
      const data = await response.json(); 
          
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getMarketplaceCostListValidation = createAsyncThunk(
  "get/getMarketplaceCostListValidation",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const response = await fetch(
        `${proxy}/api/v1/marketPlace/getAllMappedDataForMarketPlaceCost`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
        }
      )
      handleResponseCode(response);
      const data = await response.json(); 
          
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const DeleteMarketplaceCost = createAsyncThunk(
  "post/DeleteMarketplaceCost",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");

    const { payload } =props;
    try {
      const response = await fetch(
        `${proxy}/api/v1/marketPlace/delete/MarketPlace`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      )
      handleResponseCode(response);
      const data = await response.json(); 
          
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getMarketplaceOverviewCostList = createAsyncThunk(
  "post/getMarketplaceOverviewCostList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");

    const { payload, pageNumber, pageLimit } =props;
    try {
      const response = await fetch(
        `${proxy}/api/v1/marketPlace/list/marketPlaceOverViewListAndCount/${pageNumber}/1000`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      )
      handleResponseCode(response);
      const data = await response.json(); 
          
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

  export const ExportCSV = createAsyncThunk(
    "get/ExportCSV",
    async (props) => {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      try {
        const response = await fetch(
          `${proxy}/api/v1/marketPlace/download/marketPlaceCsv`,
          {
            method: 'GET',
            headers: {
              Accept: '*/*',
              "Content-Type": "application/json",
              USERNAME: User,
              "CMTS-API-TOKEN": Apitoken,
            },
          }
        );
        handleResponseCode(response);
        const data = await response.blob();
  
        return response.ok ? data : Promise.reject(data);
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    }
  );

const MarketplaceSlice = createSlice({
  name: "MarketplaceSlice",
  initialState: {
    applicationListData : [],
    applicationDataLoading : false,
    saveorUpdateData : [],
    saveorUpdateLoading : false,
    marketplaceListData : [],
    marketplaceListDataLoading : false,
    marketplaceDeleteData : [],
    marketplaceDeleteLoading : false,
    marketplaceOverviewData : [],
    marketplaceOverviewLoading : false,
    marketplaceListDataValidationData : [],
    marketplaceListDataValidationLoading : false,
    CSVloading : false,
    CSVDetails: [],
    error: false,
  },
  reducers: {
  },
    extraReducers: (builder) => {
      builder
        //getApplicationList
        .addCase(getApplicationList.pending, (state, action) => {
          state.applicationDataLoading = true;
          state.error = false;
        })
        .addCase(getApplicationList.fulfilled, (state, action) => {
          state.applicationDataLoading = false;
          state.applicationListData = action.payload;
          state.error = false;
        })
        .addCase(getApplicationList.rejected, (state, action) => {
          state.applicationDataLoading = false;
          state.applicationListData = [];
          state.error = true;
        })

        //SaveOrUpdate Marketplace
        .addCase(SaveMarketCost.pending, (state, action) => {
          state.saveorUpdateLoading = true;
          state.error = false;
        })
        .addCase(SaveMarketCost.fulfilled, (state, action) => {
          state.saveorUpdateLoading = false;
          state.saveorUpdateData = action.payload;
          state.error = false;
        })
        .addCase(SaveMarketCost.rejected, (state, action) => {
          state.saveorUpdateLoading = false;
          state.saveorUpdateData = [];
          state.error = true;
        })

        //List Marketplace
        .addCase(getMarketplaceCostList.pending, (state, action) => {
          state.marketplaceListDataLoading = true;
          state.error = false;
        })
        .addCase(getMarketplaceCostList.fulfilled, (state, action) => {
          state.marketplaceListDataLoading = false;
          state.marketplaceListData = action.payload;
          state.error = false;
        })
        .addCase(getMarketplaceCostList.rejected, (state, action) => {
          state.marketplaceListDataLoading = false;
          state.marketplaceListData = [];
          state.error = true;
        })


        
        //Delete Marketplace
        .addCase(DeleteMarketplaceCost.pending, (state, action) => {
          state.marketplaceDeleteLoading = true;
          state.error = false;
        })
        .addCase(DeleteMarketplaceCost.fulfilled, (state, action) => {
          state.marketplaceDeleteLoading = false;
          state.marketplaceDeleteData = action.payload;
          state.error = false;
        })
        .addCase(DeleteMarketplaceCost.rejected, (state, action) => {
          state.marketplaceDeleteLoading = false;
          state.marketplaceDeleteData = [];
          state.error = true;
        })

        
        //List Marketplace Overview
        .addCase(getMarketplaceOverviewCostList.pending, (state, action) => {
          state.marketplaceOverviewLoading = true;
          state.error = false;
        })
        .addCase(getMarketplaceOverviewCostList.fulfilled, (state, action) => {
          state.marketplaceOverviewLoading = false;
          state.marketplaceOverviewData = action.payload;
          state.error = false;
        })
        .addCase(getMarketplaceOverviewCostList.rejected, (state, action) => {
          state.marketplaceOverviewLoading = false;
          state.marketplaceOverviewData = [];
          state.error = true;
        })

        //Export CSV
        .addCase(ExportCSV.pending, (state, action) => {
          state.CSVloading = true;
          state.apierror = false;
        })
        .addCase(ExportCSV.fulfilled, (state, action) => {
          state.CSVDetails = action.payload;
          state.CSVloading = false;
          state.apierror = false;
        })
        .addCase(ExportCSV.rejected, (state, action) => {
          state.CSVloading = false;
          state.apierror = true;
        })

        //Export CSV
        .addCase(getMarketplaceCostListValidation.pending, (state, action) => {
          state.marketplaceListDataValidationLoading = true;
          state.apierror = false;
        })
        .addCase(getMarketplaceCostListValidation.fulfilled, (state, action) => {
          state.marketplaceListDataValidationData = action.payload;
          state.marketplaceListDataValidationLoading = false;
          state.apierror = false;
        })
        .addCase(getMarketplaceCostListValidation.rejected, (state, action) => {
          state.marketplaceListDataValidationLoading = false;
          state.apierror = true;
        })
    }
});

export const {} = MarketplaceSlice.actions;

export default MarketplaceSlice.reducer;
